import { Injectable, OnDestroy } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { AccessRequestSocketService } from './access-request-socket.service';
import { NotificationsService } from './homepage-notifications.service';
import { PublishRequestSocketService } from './publish-request-socket.service';
import { SocketMiddlewareService } from './socket-middleware.service';
import { NotificationsEvents } from 'icreate/common/io-event/websocket-message';

@Injectable({ providedIn: 'root' })
export class NotificationsSocketService implements OnDestroy {
    private destroySubscriptions$: Subject<void> = new Subject();

    private newNotification$: Subject<any> = new Subject<any>();
    private updateNotification$: Subject<any> = new Subject<any>();

    constructor(
        private socketService: SocketMiddlewareService,
        private notificationsService: NotificationsService,
        private accessRequestSocketService: AccessRequestSocketService,
        private publishRequestService: PublishRequestSocketService
    ) {}

    ngOnDestroy(): void {
        this.destroySubscriptions();
    }

    startSubscriptions() {
        this.destroySubscriptions();
        this.destroySubscriptions$ = new Subject();

        this.subscribeToEvent(this.accessRequestSocketService.startedEditing$());
        this.subscribeToEvent(this.accessRequestSocketService.finishedEditing$());
        this.subscribeToEvent(this.accessRequestSocketService.requestUpdated$());
        this.subscribeToEvent(this.accessRequestSocketService.requestCreated$());
        this.subscribeToEvent(this.accessRequestSocketService.leftEditing$());

        this.subscribeToEvent(this.publishRequestService.publishRequestCreated$());
        this.subscribeToEvent(this.publishRequestService.publishRequestAccepted$());
        this.subscribeToEvent(this.publishRequestService.publishRequestRejected$());

        this.notificationUpdated$();
    }

    private subscribeToEvent(event$) {
        event$.pipe(takeUntil(this.destroySubscriptions$)).subscribe(async data => {
            const notification = this.notificationsService.filterNotifications([data])[0];
            if (notification) {
                this.updateNotificationList(notification);
            }
        });
    }

    updateNotificationList(notification) {
        this.newNotification$.next(notification);
    }

    updateNotificationSubject() {
        return this.updateNotification$;
    }

    newNotificationSubject(): Subject<void> {
        return this.newNotification$;
    }

    destroySubscriptions() {
        this.destroySubscriptions$.next();
        this.destroySubscriptions$.complete();
    }

    notificationUpdated$() {
        this.socketService
            .receiveMessageObserver(NotificationsEvents.NOTIFICATION_UPDATED)
            .pipe(takeUntil(this.destroySubscriptions$))
            .subscribe(updatedNotification => {
                if (updatedNotification.messageRead) this.updateNotification$.next(updatedNotification);
                else {
                    const shouldEmit = this.notificationsService.filterNotifications([updatedNotification])[0];
                    if (shouldEmit) {
                        this.updateNotificationList(updatedNotification);
                    }
                }
            });
    }
}
